import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { Auth0User } from "./UsersData";

export function makeUserFields(): FilterField<Auth0User>[] {
  const fields: FilterField<Auth0User>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Email",
      key: "email",
      accessor: (r) => r.email,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Status",
      key: "status",
      accessor: (r) => r.status,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Role",
      key: "role",
      accessor: (r) => r.roles.map((role) => role.name).join(" "),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Last login",
      key: "lastlogin",
      accessor: (r) => (r.last_login ? new Date(r.last_login) : null),
      type: "date",
      inFreeText: false,
    },
  ];

  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

